import { useQueryClient } from 'react-query';
import { ShowButton } from '../PaymentDocuments/PaymentDocuments.styled';
import { Popconfirm } from 'antd';
import React, { useState } from 'react';
import { ContentWrapper } from '../../_common';
import {
 Content,
 Contract,
 ContractData,
 ContractNumber,
 ContractType,
} from '../Contracts/Contracts.styled';
import srv from '../../../services';
import moment from 'moment';
import {
 Box,
 Button,
 TextField,
 Alert,
 Snackbar,
 MenuItem,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ruLocale from 'dayjs/locale/ru';
import dayjs, { Dayjs } from 'dayjs';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
 docType: {
  width: '380px',
  marginLeft: '-26px !Important',
  '& .MuiInputBase-root': {
   height: '32px !Important',
   fontSize: '12px !Important',
  },
  '& .MuiSelect-select': {
   fontSize: '12px !Important',
  },
  '& .MuiInputLabel-root': {
   fontSize: '12px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
 menuItem: {
  fontSize: '12px !Important',
  paddingY: '6px !Important',
 },
 email: {
  width: '260px',
  marginLeft: '-6px !Important',
  '& .MuiInputBase-root': {
   height: '32px',
   fontSize: '13px',
  },
  '& .MuiSelect-select': {
   fontSize: '13px',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
 datePicker: {
  width: '380px',
  '& .MuiInputBase-root': {
   height: '32px',
   fontSize: '13px',
  },
  '& .MuiSelect-select': {
   fontSize: '13px',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
});

const Notifications = () => {
 const notifications = useQueryClient().getQueryData<any>('notifications');
 const queryClient = useQueryClient();
 const classes = useStyles();

 const [startDate, setStartDate] = useState<Dayjs | null>(null);
 const [endDate, setEndDate] = useState<Dayjs | null>(null);
 const [buttonVisible, setButtonVisible] = useState<boolean>(true);
 const [errors, setErrors] = useState<{ [key: string]: string }>({});

 //  const base64toBlob = (data: string) => {
 //   if (!data) {
 //    return new Blob();
 //   }

 //   try {
 //    const bytes = atob(data);
 //    let length = bytes.length;
 //    let out = new Uint8Array(length);

 //    while (length--) {
 //     out[length] = bytes.charCodeAt(length);
 //    }

 //    return new Blob([out], { type: 'application/pdf' });
 //   } catch (e: any) {
 //    console.log('error');
 //   }
 //  };

 const readMessage = (notification: any) => {
  try {
   //  const link = document.createElement('a');
   //  link.href = URL.createObjectURL(base64toBlob(notification.fileContent));
   //  link.target = '_blank';
   //  link.download = notification.typeName;
   //  document.body.appendChild(link);
   //  link.click();
   //  link.remove();

   srv
    .setNotificationReadStatus({
     notificationId: notification.id,
     isRead: true,
    })
    .then((res: any) => {
     queryClient.refetchQueries('notifications');
     queryClient.refetchQueries('notificationNotReadCount');
    })
    .catch(() => console.error('Произошла неизвестная ошибка!'));
  } catch (e) {
   console.log('ERROR', e);
  }
 };

 const filterData = () => {};

 return (
  <>
   <ContentWrapper>
    {/* <Box
     sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: 2,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      justifyItems: 'center',
      alignContent: 'center',
     }}
    >
     <Box sx={{ display: 'flex', gap: 1, width: '700px' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ruLocale}>
       <DatePicker
        label="Начало периода"
        inputFormat="DD.MM.YYYY"
        value={startDate}
        onChange={(newValue) => setStartDate(newValue)}
        renderInput={(params) => (
         <TextField
          {...params}
          size="small"
          error={!!errors.range}
          helperText={errors.range}
          fullWidth
          className={classes.datePicker}
         />
        )}
       />
      </LocalizationProvider>

      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ruLocale}>
       <DatePicker
        label="Окончание периода"
        inputFormat="DD.MM.YYYY"
        value={endDate}
        onChange={(newValue) => setEndDate(newValue)}
        renderInput={(params) => (
         <TextField
          {...params}
          error={!!errors.range}
          fullWidth
          size="small"
          className={classes.datePicker}
         />
        )}
       />
      </LocalizationProvider>

      {buttonVisible && (
       <ShowButton size="small" variant="contained" onClick={filterData}>
        Просмотреть
       </ShowButton>
      )}
     </Box>
    </Box> */}

    <Content>
     {notifications?.map((notification) => (
      <Contract
       key={notification.id}
       onClick={() => readMessage(notification)}
       style={{ cursor: notification?.isRead ? 'default' : 'pointer' }}
      >
       <ContractData>
        {/* <ContractType></ContractType> */}

        <div
         style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          wordBreak: 'break-word',
          width: '220px',
          fontWeight: notification?.isRead ? 200 : 700,
         }}
        >
         {' '}
         {notification.title} <br />
        </div>

        {/* <div
         style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          wordBreak: 'break-word',
          width: '220px',
          fontWeight: '200',
         }}
        >
         {' '}
         {notification.newStatus}
        </div> */}

        <ContractNumber
         style={{ fontWeight: notification?.isRead ? 200 : 700 }}
        >
         {notification.description}
        </ContractNumber>

        {/* <ContractNumber>
         <u>Номер договора</u> {notification.contractNumber}
        </ContractNumber> */}

        <ContractNumber
         style={{ fontWeight: notification?.isRead ? 200 : 700 }}
        >
         {/* <u>Дата</u>{' '} */}
         {notification.createDate
          ? moment
             .utc(notification.createDate)
             .local()
             .format('DD.MM.YYYY HH:MM')
          : ''}
        </ContractNumber>

        {/* <ContractNumber>
         <u>Состояние</u>
         <label style={{ color: notification.isRead ? 'black' : 'red' }}>
          {notification.isRead ? 'Прочитано' : 'Не прочитано'}
         </label>
        </ContractNumber> */}

        {/* <Popconfirm
         title="Вы уверены?"
         okButtonProps={{ danger: true }}
         okText="Да"
         cancelText="Отмена"
         onConfirm={() => {
          try {
           const link = document.createElement('a');
           link.href = URL.createObjectURL(
            base64toBlob(notification.fileContent),
           );
           link.target = '_blank';
           link.download = notification.typeName;
           document.body.appendChild(link);
           link.click();
           link.remove();

           srv
            .setNotificationReadStatus({
             notificationId: notification.id,
             isRead: true,
            })
            .then((res: any) => {
             queryClient.refetchQueries('notifications');
             queryClient.refetchQueries('notificationNotReadCount');
            })
            .catch(() => console.error('Произошла неизвестная ошибка!'));
          } catch (e) {
           console.log('ERROR', e);
          }
         }}
        >
         {!notification?.isRead && <SubmitButton>Ознакомиться</SubmitButton>}
        </Popconfirm> */}
       </ContractData>
      </Contract>
     ))}
    </Content>
   </ContentWrapper>
  </>
 );
};

export default Notifications;
